import { useNavigate } from '@tanstack/react-router'
import { useRecordPlayDraft } from '../../stores/recordPlayDraft'

const toLocalDateTimeInput = (iso: string): string => {
  const d = new Date(iso)
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export const RecordDetailsStep = () => {
  const navigate = useNavigate()
  const draft = useRecordPlayDraft()
  const groupId = draft.groupId

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span className="kicker">When</span>
        <input
          type="datetime-local"
          value={toLocalDateTimeInput(draft.playedAt)}
          onChange={(e) =>
            draft.setDetails({ playedAt: new Date(e.currentTarget.value).toISOString() })
          }
        />
      </label>

      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span className="kicker">Duration (minutes)</span>
        <input
          type="number"
          inputMode="numeric"
          value={draft.durationMinutes ?? ''}
          onChange={(e) => {
            const v = e.currentTarget.value
            draft.setDetails({ durationMinutes: v === '' ? null : Number(v) })
          }}
        />
      </label>

      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span className="kicker">Location</span>
        <input
          type="text"
          value={draft.location}
          placeholder="Cora's kitchen table"
          onChange={(e) => draft.setDetails({ location: e.currentTarget.value })}
        />
      </label>

      <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span className="kicker">Notes</span>
        <textarea
          rows={4}
          value={draft.notes}
          placeholder="Notes, expansion details, the dramatic moment…"
          onChange={(e) => draft.setDetails({ notes: e.currentTarget.value })}
        />
      </label>

      <button
        type="button"
        className="btn-stamp"
        onClick={() => {
          if (groupId) navigate({ to: '/group/$id/record/confirm', params: { id: groupId } })
          else navigate({ to: '/record/confirm' })
        }}
      >
        Continue
      </button>
    </div>
  )
}
